import React, { useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { Grid, Typography, Button, makeStyles, useTheme } from '@material-ui/core'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'

import { useLiterals } from '~/components/Literals'
import useViewportSize from '~/components/useViewportSize'

import AreaChartPrice from '~/components/Chart/AreaChart'
import DrawerAlertPrice from './DrawerAlertPrice'

import { selectChart } from '~/selectors'
import track from '~/track'

const useStyles = makeStyles(() => ({
  card: {
    width: '100%',
    padding: 16,
    background: '#F9F9F9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardGraph: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    cursor: 'pointer',
    gap: 4,
  },
}))

export default function CardsEcommerce({ product, color }) {
  const [chart] = useSelector(selectChart, shallowEqual)
  const [open, setOpen] = useState(false)

  const classes = useStyles()
  const theme = useTheme()
  const viewport = useViewportSize()
  const { getLiteral } = useLiterals()

  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const { data, period, load } = chart

  const dataChart = data.map(({ date, lowestPrice }) => ({
    date: new Date(date),
    value: lowestPrice,
  }))

  const handleOpen = (key, product) => {
    key === 'variantPrice'
      ? track('verPrecoOnline', { category: 'produto', name: product?.name })
      : track('alertaPrecoOnline', {
          category: 'produto',
          name: product?.name,
        })

    setOpen(true)
  }

  const handleClose = () => setOpen(false)

  return (
    <>
      <Grid container className={classes.card}>
        <Grid
          item
          className={classes.cardGraph}
          {...(isMobile && {
            style: {
              flexDirection: 'column',
            },
          })}
          onClick={() => handleOpen('variantPrice', product)}
        >
          <AreaChartPrice onlyGraphich data={dataChart} color={color} width={isMobile ? 150 : 200} height={50} />
          <Typography style={{ textDecoration: 'underline' }}>{getLiteral('2535')}</Typography>
        </Grid>

        <Button
          variant="contained"
          disableElevation
          startIcon={<AttachMoneyIcon color="primary" />}
          onClick={() => handleOpen('alertPrice', product)}
        >
          {getLiteral('2542')}
        </Button>
      </Grid>

      <DrawerAlertPrice
        product={product}
        open={open}
        color={color}
        onClose={handleClose}
        periodChart={period}
        loadChart={load}
        dataChart={dataChart}
      />
    </>
  )
}
